module.exports = __webpack_public_path__ + "static/media/9DESA30.0d2e1b3b.jpg";